import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Attendance from './pages/Attendance';
import EmployeeDetails from './pages/EmployeeDetails';
import UserDetails from './pages/userDetails';
import StockIn from './pages/StockIn';
import StockOut from './pages/StockOut';
import Transport from './pages/Transport';
import Reports from './pages/Reports';
import Reports1 from './pages/Reports1';
import Vendors from './pages/Vendors';
import Gallery from './pages/Gallery';
import AdvanceDetails from './pages/AdvanceDetails';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Maintenance from './pages/Maintenance';
import AttendanceSettings from './pages/maintenance/AttendanceSettings';
import UserSettings from './pages/maintenance/UserSettings';
import SiteSettings from './pages/maintenance/SiteSettings';
import StockInSettings from './pages/maintenance/StockInSettings';
import StockOutSettings from './pages/maintenance/StockOutSettings';
import TransportSettings from './pages/maintenance/TransportSettings';
import VendorSettings from './pages/maintenance/VendorSettings';
import DefaultSettings from './pages/maintenance/DefaultSettings';
import GallerySettings from './pages/maintenance/GallerySettings';
import MaterialType from './pages/maintenance/MaterialType';
import PlantMaintenance from './pages/maintenance/PlantMaintenance';
import SiteMaintenance from './pages/maintenance/SiteMaintenance';
import TransportMaintenance from './pages/maintenance/TransportMaintenance';
import SupervisorMaintenance from './pages/maintenance/SupervisorMaintenance';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
        {/* Redirect root to login */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        
        {/* Login page without layout */}
        <Route 
          path="/login" 
          element={
            <Layout showLayout={false}>
              <Login />
            </Layout>
          } 
        />
        
        {/* Signup page without layout */}
        <Route 
          path="/signup" 
          element={
            <Layout showLayout={false}>
              <Signup />
            </Layout>
          } 
        />
        
        {/* Dashboard page with layout */}
        <Route 
          path="/dashboard" 
          element={
            <Layout>
              <Dashboard />
            </Layout>
          } 
        />
        <Route 
          path="/attendance" 
          element={
            <Layout>
              <Attendance />
            </Layout>
          } 
        />
        <Route 
          path="/employee-details" 
          element={
            <Layout>
              <EmployeeDetails />
            </Layout>
          } 
        />
        <Route 
          path="/userDetails" 
          element={
            <Layout>
              <UserDetails />
            </Layout>
          } 
        />
        <Route 
          path="/stock-in" 
          element={
            <Layout>
              <StockIn />
            </Layout>
          } 
        />
        <Route 
          path="/advance-details" 
          element={
            <Layout>
              <AdvanceDetails />
            </Layout>
          } 
        />
        <Route 
          path="/stock-out" 
          element={
            <Layout>
              <StockOut />
            </Layout>
          } 
        />
        <Route 
          path="/transport" 
          element={
            <Layout>
              <Transport />
            </Layout>
          } 
        />
        <Route 
          path="/reports" 
          element={
            <Layout>
              <Reports />
            </Layout>
          } 
        />
        <Route 
          path="/reports1" 
          element={
            <Layout>
              <Reports1 />
            </Layout>
          } 
        />
        <Route 
          path="/vendors" 
          element={
            <Layout>
              <Vendors />
            </Layout>
          } 
        />
        <Route 
          path="/gallery" 
          element={
            <Layout>
              <Gallery />
            </Layout>
          } 
        />
        <Route 
          path="/advance-details" 
          element={
            <Layout>
              <AdvanceDetails />
            </Layout>
          } 
        />
        <Route 
          path="/maintenance/*" 
          element={
            <Layout>
              <Maintenance />
            </Layout>
          }
        >
          <Route path="attendance" element={<AttendanceSettings />} />
          <Route path="users" element={<UserSettings />} />
          <Route path="sites" element={<SiteSettings />} />
          <Route path="stock-in" element={<StockInSettings />} />
          <Route path="material-type" element={<MaterialType />} />
          <Route path="plants" element={<PlantMaintenance />} />
          <Route path="maintenance-sites" element={<SiteMaintenance />} />
          <Route path="transport-master" element={<TransportMaintenance />} />
          <Route path="supervisor-master" element={<SupervisorMaintenance />} />
          <Route path="stock-out" element={<StockOutSettings />} />
          <Route path="transport" element={<TransportSettings />} />
          <Route path="vendors" element={<VendorSettings />} />
          <Route path="default" element={<DefaultSettings />} />
          <Route path="gallery" element={<GallerySettings />} />
        </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
